/* eslint-disable react-hooks/exhaustive-deps */
import { CRow } from "@coreui/react";
import { CButton, CCol } from "@coreui/react";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "./LoginWithOTP.css";
import logo1024 from "../../../assets/logo1024.png";
import Loader from "../../../Components/loader/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg_image from "../../../assets/evacassets/image/bg_gradient.png";
import logo_new from "../../../assets/evacassets/image/logo.png";
import CustomInput from "../../../Components/New_Components/CustomInput";
import CustomButton from "../../../Components/New_Components/CustomButton";

const LoginWithOTP = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [timer, setTimer] = useState(0);
  const notify = (message) => toast(message);
  const [theme, setTheme] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const sendOTP = (p) => {
    setTimer(30);
    console.log("send otp " + p);
    setLoading(true);
    // const proxyUrl = "/api/sendOtp?phone=" + p;
    const proxyUrl = `/api/sendOtp?phone=${p}&pushToken=${null}`;
    axios
      .post(proxyUrl, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          // 'Access-Control-Allow-Origin' : '*',
        },
      })
      .then((response) => {
        if (response.status === 202) {
          console.log("resp " + response.data);
          notify("OTP send on +91" + p, {
            type: "success",
            theme: theme === "dark" ? "light" : "dark",
          });
          setLoading(false);
        } else {
          setLoading(false);
          notify("Something went wrong", {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
        }
      })
      .catch((e) => {
        if (e.response.data.err) {
          setLoading(false);
          notify(e.response.data.err, {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
        } else {
          setLoading(false);
          notify("Something went wrong", {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
        }
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.length < 10 || phone.length > 10) {
      if (phone === "") {
        notify("Phone Number is required", {
          type: "error",
          theme: theme === "dark" ? "light" : "dark",
        });
      } else {
        notify("Please enter valid phone number", {
          type: "error",
          theme: theme === "dark" ? "light" : "dark",
        });
      }
    } else if (otp === "") {
      notify("Please enter the OTP", {
        type: "error",
        theme: theme === "dark" ? "light" : "dark",
      });
    } else {
      const proxyUrl = "/api/loginOtp?phone=" + phone + "&otp=" + otp;
      setLoading(true);
      axios
        .post(proxyUrl, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((response) => {
          if (response.status === 202) {
            console.log(response.data);
            setLoading(false);
            notify("Successfully Logged In", {
              type: "success",
              theme: theme === "dark" ? "light" : "dark",
            });
            localStorage.setItem("user", JSON.stringify(response.data));
            console.log(response.data);
            localStorage.setItem("token", response.data.userId);
            localStorage.setItem("Jtoken", response.data.token);
            localStorage.setItem("phone", phone);
            localStorage.setItem(
              "profilePicture",
              response.data.profilePicture
            );
            const current = new Date();
            const ExTime = current.getDate() + 7;
            localStorage.setItem("ExTime", ExTime);
            navigate("/dashboard");
            setLoading(true);
          } else {
            setLoading(false);
            notify("Something went wrong", {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data.err) {
            setLoading(false);
            notify(e.response.data.err, {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          } else {
            setLoading(false);
            notify("Something went wrong", {
              type: "error",
              theme: theme === "dark" ? "light" : "dark",
            });
          }
        });
    }
  };
  useEffect(() => {
    console.log(phone, timer);
    if (phone && phone.length === 10 && timer === 0) {
      console.log(phone);
      sendOTP(phone);
    }
  }, [phone]);
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row font-roboto">
      <ToastContainer />
      <div className="w-full md:w-1/2 flex flex-col justify-center py-10  ">
        <div className="p-4 lg:px-14 lg:mx-24">
          <h1 className="font-bold mb-4">Get Started</h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <CustomInput
              id="number"
              label="Phone Number"
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="Enter phone number"
              minLength={10}
              maxLength={10}
              required
            />

            <CustomInput
              id="otp"
              label="Otp"
              type="tel"
              value={otp}
              onChange={handleOtpChange}
              placeholder="Enter otp"
              required
            />

            <div className="text-right mt-1 mb-2">
              {timer === 0 ? (
                <button
                  type="button"
                  onClick={() => sendOTP(phone)}
                  className={`text-sm ${
                    phone.length === 10
                      ? "text-blue-600 hover:underline"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  disabled={phone.length !== 10}
                >
                  Send OTP
                </button>
              ) : (
                <p className="text-sm text-gray-500">
                  Resend OTP in {timer} secs
                </p>
              )}
            </div>

            <CustomButton
              title="Login"
              disabled={isLoading}
              onPress={handleSubmit}
            />
          </form>

          {/* Extra Links */}
          <div className="text-sm text-center text-gray-600 space-y-4 mt-4">
            <div className="flex items-center gap-4 text-gray-500">
              <hr className="flex-grow border-gray-600" />
              <span className="text-sm font-medium">OR</span>
              <hr className="flex-grow border-gray-600" />
            </div>

            {/* Login with OTP */}
            <p>
              <CustomButton
                title="Login with Password"
                // disabled={loading}
                onPress={() => navigate("/loginwithpassword")}
                filledColor="transparent"
                textColor="#000"
              />
            </p>

            {/* Sign up */}
            <p>
              Don't have an account?{" "}
              <button
                type="button"
                onClick={() => navigate("/register")}
                className="text-blue-600 hover:underline"
              >
                Sign up
              </button>
            </p>
          </div>
        </div>
      </div>

      <div
        className="hidden md:flex w-full md:w-1/2 relative bg-cover bg-center items-center justify-center"
        style={{ backgroundImage: `url(${bg_image})` }}
      >
        <div className="bg-white rounded-xl p-8 py-14 w-[90%] md:w-[60%] mx-auto">
          <div className="w-[80%] text-black text-justify space-y-4">
            <div className="mb-6">
              <img src={logo_new} alt="Logo" className="w-40" />
            </div>
            <h2 className="text-3xl font-semibold text-left">
              Manage Your <br /> Charging Ecosystem
            </h2>
            <p className="text-sm md:text-base text-gray-600 text-left">
              Pyramid Home Charge lets you add and monitor multiple chargers
              from one place. Stay connected, organized, and in control.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWithOTP;
